module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markCorrect--dark-ed0ace1a0f58d42bf9291809652ce850.png";